module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/demo2025/ortho-field-config-translation.json
// module id = 1272
// module chunks = 0